// import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/styled-engine";
import "antd/dist/reset.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "react-phone-number-input/style.css";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./app/components/scss/index.scss";
import store, { persistor } from "./app/redux/store";
import reportWebVitals from "./reportWebVitals";

const { PUBLIC_URL } = process.env;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <StyledEngineProvider injectFirst>
            <BrowserRouter basename={PUBLIC_URL}>
                {/* <ThemeProvider theme={theme}> */}
                <CssBaseline />
                <App store={store} persistor={persistor} />
                {/* </ThemeProvider> */}
            </BrowserRouter>
        </StyledEngineProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
